var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full overflow-auto"},[_c('TimetableTimeline'),_c('div',{staticClass:"flex",style:(_vm.styles)},[_c('TimetableSidebar'),_c('div',{staticClass:"flex flex-col"},_vm._l((_vm.months),function(month,$i){return _c('TimetableRow',{key:$i,attrs:{"month":month}})}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }